import cx from 'clsx';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import { getSeverityLevelList } from '@components/modals/CompletionReportModal/helpers/getSeverityLevelList';

import useTranslation from '@hooks/useTranslation';

import type { IAIReport, ICauseCategorySeverity } from '@model/aiReport';

import style from './style.module.scss';

interface IProps {
  actionItemType?: string;
  isArchived?: boolean;
  report: IAIReport;
}

const MaintenanceDetails: React.FC<IProps> = ({ actionItemType = '', report }) => {
  const { t } = useTranslation();

  const severityLevelList = getSeverityLevelList(t);

  if (actionItemType !== 'regular' || report.no_actions_type) {
    return null;
  }

  return (
    <div className={style.maintenanceBlock}>
      <div className={style.maintenanceTitle}>{t('Metrics Information')}</div>
      <table className={style.maintenanceTable} cellSpacing="0" cellPadding="0">
        <thead className={style.maintenanceTableHead}>
          <tr>
            <th className={style.maintenanceTableTh}>{t('Severity')}</th>
            <th className={style.maintenanceTableTh}>{t('Cause category')}</th>
          </tr>
        </thead>
        <tbody className={style.maintenanceTableBody}>
          {report.causeCategorySeverities.map((category: ICauseCategorySeverity, i: number) => (
            <tr key={uuidv4()} className={style.maintenanceTableBodyRow}>
              <td className={cx(style.maintenanceTableTd, style.severityTd)}>
                <div className={style.tableText} data-qa={`causeCategorySeverities[${i}][severity]`}>
                  {severityLevelList.find((level) => level.id === +category.severity)?.name || ''}
                </div>
              </td>
              <td className={style.maintenanceTableTd}>
                <div className={style.tableField} data-qa={`causeCategorySeverities[${i}][cause_category]`}>
                  {t(category.cause_category)}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MaintenanceDetails;
